import React, { useState } from 'react';
import Icon from '@common/assets';
import ApplyNotice from '@components/jobflexLoginModal/login/applyNotice';
import classnames from 'classnames/bind';
import styles from './Title.module.scss';
const cx = classnames.bind(styles);

const Title = () => {
  const [openApplyNotice, setOpenApplyNotice] = useState(false);

  return (
    <div className={cx('titleArea')}>
      <Icon name="logo" width={108} height={24} />
      <div className={cx('titleWrap')}>
        <span className={cx('subTitle')}>역량 기반의 취업 매칭 플랫폼</span>
        <strong className={cx('title')}>JOBDA로 통합 지원하기</strong>
      </div>
      <div className={cx('descWrap')}>
        <span className={cx('desc')}>
          통합 계정 하나로 750개 이상의 기업에 쉽게 지원할 수 있어요.
          <a className={cx('infoBtn')} role="button" onClick={() => setOpenApplyNotice(!openApplyNotice)} />
        </span>
        <ApplyNotice isVisible={openApplyNotice} onClose={() => setOpenApplyNotice(false)} />
      </div>
    </div>
  );
};

export default Title;
